import { getFilterIndicator } from "../helpers";

import { formatStaffName } from "@/lib/format-data";

import type { FilterStrategy } from "./types";

export const providerStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (!ctx.providers || ctx.providers.length === 0) return;
    const q = ctx.query;
    for (const provider of ctx.providers) {
      const fullName = formatStaffName(provider);
      const nameLower = fullName.toLowerCase();
      const firstNameLower = provider.firstName?.toLowerCase() ?? "";
      const lastNameLower = provider.lastName?.toLowerCase() ?? "";

      if (
        nameLower.includes(q) ||
        firstNameLower.includes(q) ||
        lastNameLower.includes(q)
      ) {
        const isExact = nameLower === q;
        const startsWithQuery =
          firstNameLower.startsWith(q) || lastNameLower.startsWith(q);
        out.push({
          filterKey: filterType.filterKey,
          filterLabel: filterType.label,
          optionValue: provider.id,
          optionLabel: fullName,
          type: filterType.type,
          score: isExact ? 90 : startsWithQuery ? 75 : 50,
          indicator: getFilterIndicator(filterType),
        });
      }
    }
  },
  isSelected(currentValue, optionValue) {
    return currentValue === optionValue;
  },
  toggle(result) {
    return { value: result.optionValue, clearSearchQuery: true };
  },
};
